import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: true,
    error: null,
    uid: null,
    domain: null,

    analytics: {
        enabled: false,
        overage: false,
        quotaMinutes: null,
        usedMinutes: 0,
        remainingMinutes: null,
    },
    callAssistant: {
        enabled: false,
        overage: false,
        quotaMinutes: null,
        usedMinutes: 0,
        remainingMinutes: null,
    },
    chatAssistant: {
        enabled: false,
        overage: false,
        quotaCredits: null,
        usedCredits: 0,
        remainingCredits: null,
    },
};

export const analyticSubscriptionUsageSlice = createSlice({
    name: 'analyticSubscriptionUsage',
    initialState,
    reducers: {
        setAnalyticSubscriptionUsage: (state, action) => {
            const { uid, domain, analytics, callAssistant, chatAssistant } = action.payload || {};
            
            state.loading = false;
            state.error = null;

            if (uid != null) state.uid = uid;
            if (domain != null) state.domain = domain;

            if (analytics) {
                state.analytics.enabled = !!analytics.enabled;
                state.analytics.overage = !!analytics.overage;
                state.analytics.quotaMinutes = analytics.quotaMinutes ?? null;
                state.analytics.usedMinutes = analytics.usedMinutes ?? 0;
                state.analytics.remainingMinutes = analytics.remainingMinutes ?? null;
            }
            if (callAssistant) {
                state.callAssistant.enabled = !!callAssistant.enabled;
                state.callAssistant.overage = !!callAssistant.overage;
                state.callAssistant.quotaMinutes = callAssistant.quotaMinutes ?? null;
                state.callAssistant.usedMinutes = callAssistant.usedMinutes ?? 0;
                state.callAssistant.remainingMinutes = callAssistant.remainingMinutes ?? null;
            }
            if (chatAssistant) {
                state.chatAssistant.enabled = !!chatAssistant.enabled;
                state.chatAssistant.overage = !!chatAssistant.overage;
                state.chatAssistant.quotaCredits = chatAssistant.quotaCredits ?? null;
                state.chatAssistant.usedCredits = chatAssistant.usedCredits ?? 0;
                state.chatAssistant.remainingCredits = chatAssistant.remainingCredits ?? null;
            }
        },


        resetAnalyticSubscriptionUsage: () => initialState,
    },
});

export const { 
    setAnalyticSubscriptionUsage, 
    resetAnalyticSubscriptionUsage 
} = analyticSubscriptionUsageSlice.actions;

export const selectAnalyticSubscriptionUsage = (state) => state.analyticSubscriptionUsage;
export const selectAnalyticsUsage = (state) => state.analyticSubscriptionUsage.analytics;
export const selectCallAssistantUsage = (state) => state.analyticSubscriptionUsage.callAssistant;
export const selectChatAssistantUsage = (state) => state.analyticSubscriptionUsage.chatAssistant;

export default analyticSubscriptionUsageSlice.reducer;